import script from "./FooterBar.vue?vue&type=script&setup=true&name=FooterBar&lang=js"
export * from "./FooterBar.vue?vue&type=script&setup=true&name=FooterBar&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=78a2fc57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a2fc57"]])

export default __exports__